export default __webpack_public_path__ + "static/media/sanguineinfusion.8db82e28.png";